import header from "./foto-einer-kueche.jpg";
import section1 from "./ansicht-einer-kueche.jpg";
import section2 from "./floor-plan-kitchen.png";
import section3 from "./helle-aufgeraeumte-kueche.jpg";
import section4 from "./floor-plan-kitchen-on-tablet.png";

export { header, section1, section2, section3, section4 };
